import { IconButton } from '@creditornot/cb-button';
import { CaretDown } from '@creditornot/cb-icons';
import { elevationCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import React, { useState } from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type AdvancedViewProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const STICKY_FOOTER_HEIGHT = 80;

const Root = styled.div`
  ${elevationCss(2)}
  display: flex;
  padding: 48px;
  width: 100%;
  border-radius: 8px;
  flex-direction: column;
  gap: 24px;
  margin-block-end: ${STICKY_FOOTER_HEIGHT}px;
  background-color: ${color.bg};
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type ArrowIconButtonProps = {
  $isExpanded: boolean;
};

const ArrowIconButton = styled(IconButton).attrs({
  size: 'small',
  variant: 'neutral',
  alignment: 'boundingBox',
})<ArrowIconButtonProps>`
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease-in-out;
`;

export const ExpandableView = ({ title, description, children }: AdvancedViewProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <Root>
      <HeaderRow>
        <T.Heading6>{title}</T.Heading6>
        <ArrowIconButton
          $isExpanded={isExpanded}
          onClick={() => {
            setIsExpanded(prevState => !prevState);
          }}
        >
          <CaretDown />
        </ArrowIconButton>
      </HeaderRow>
      {isExpanded ? <>{children}</> : <T.Body3>{description}</T.Body3>}
    </Root>
  );
};
